module.exports = __webpack_public_path__ + "img/secure-epayco.e0307f51.png";